(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["torchlight-official__v0.1.0"] = factory();
	else
		root["torchlight-official__v0.1.0"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 